// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"393":"de2cc4a0","453":"523f1863","560":"c3f5172e"}[chunkId] + ".chunk.js";
};